import { Button } from "reactstrap"
import styles from './PrimaryButton.module.scss'

const PrimaryButton = ({ name, onClick, colorTheme = 'blue' }) => {
    return (
        <Button type="button" color="primary" className={`${styles.btn} ${styles[`btn-${colorTheme}`]}`} onClick={onClick}>
            {name}
        </Button>
    )
}

export default PrimaryButton